<style scoped>
</style>

<template>
  <div>
    <el-menu-item :index="data.route">
      <span :class="{active_color: data.route === activeIndex}"></span>
      <i :class="iconClass" />
      <span
        slot="title"
        :class="{active: data.route === activeIndex}"
      >
        {{ data.name }}
      </span>
    </el-menu-item>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  name: "MenuItem",
  computed: {
    iconClass() {
      return this.data.iconClass;
    }
  },
  data() {
    return {
      activeIndex: ""
    };
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta[
      this.$route.meta.length - 1
    ].activeRoute;
  },
  methods: {
    ...mapMutations(["updateActiveIndex"])
  },
  watch: {
    $route(val) {
      this.activeIndex = val.meta[val.meta.length - 1].activeRoute;
    },
    activeIndex(val) {
      this.updateActiveIndex(val);
    }
  }
};
</script>
<style scoped>
.active {
  color: #1890ff;
}
.active_color {
  display: inline-block;
  position: relative;
  left: -10px;
  width: 3px;
  height: 22px;
  background: #1890ff;
}
</style>